import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  discountedPrice: {
    fontSize: '0.8rem',
    fontWeight: 'bolder',
  },
  totalSaving: {
    display: 'flex',
    fontSize: '0.8rem',
  },
  totalSavingPrice: {
    color: theme.palette.success.main,
    fontSize: '0.8rem',
  },
  priceContainer: {
    color: theme.palette.gray.efesGray,
    fontSize: '0.8rem',
    textDecoration: 'line-through',
  },
}));

export default useStyles;
